module.exports = __webpack_public_path__ + "static/media/img-12.7297f201.jpg";